import React from "react";
import {Typography} from "../../../../designSystem/components/Typography";
import {DashboardCard} from "../../../../designSystem/components/DashboardCard";

interface SectionProps {
  title: string;
  children: React.ReactNode;
  right?: React.ReactNode;
}

export const Section = ({ title, children, right=null }: SectionProps) => (
  <DashboardCard>
    {title && (
      <div className="flex items-center justify-between mb-3">
        <Typography variant="subtitle">
          {title}
        </Typography>
        {right}
      </div>
    )}
    {children}
  </DashboardCard>
);
